import React, { Suspense, useMemo } from 'react';
import { RouterProvider } from 'react-router-dom';
import Loading from './components/Loading/Loading';
import routes from './routers/Routers';

// css
import "./css/mainCSS/app.css"
import "react-datepicker/dist/react-datepicker.css"
import "react-loading-skeleton/dist/skeleton.css"
import "@smastrom/react-rating/style.css"
import { useSelector } from 'react-redux';

function App() {
	const reduxState = useSelector((s) => s);
	const router = useMemo(() => routes({ reduxState }), [reduxState]);
	return (
		<div className="app">
			<Suspense fallback={<Loading />}>
				<RouterProvider router={router} />
			</Suspense>
		</div>
	);
}

export default App;